import React from 'react';
import { SvgIconProps } from '@mui/material';

export const SyncOutlineIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1 1V7M1 7H7M1 7C3.32744 4.91141 5.48287 2.54676 8.74532 2.08779C10.6777 1.81593 12.6461 2.17941 14.3539 3.12343C16.0617 4.06746 17.4164 5.54091 18.2139 7.32177M19 21V15M19 15H13M19 15C16.6725 17.0886 14.5171 19.4532 11.2547 19.9122C9.32229 20.1841 7.35391 19.8206 5.6461 18.8766C3.93829 17.9325 2.58356 16.4591 1.78604 14.6782"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SyncOutlineIcon;
